import { Action, createAction } from 'redux-act';

import EnableGuestWebResult from '../../../models/interfaces/EnableGuestWebResult';
import TimestampPayload from '../TimestampPayload';

export interface EnableGuestWebPayload {
  token: string;
  enable: boolean;
}
export const enableGuestWeb = createAction<EnableGuestWebPayload>('ENABLE_GUEST_WEB');
export type EnableGuestWebActionType = Action<EnableGuestWebPayload>;

export interface EnableGuestWebResultPayload extends TimestampPayload {
  enableGuestWebResult: EnableGuestWebResult;
  token: string;
}
export const enableGuestWebFinished = createAction<EnableGuestWebResultPayload>('ENABLE_GUEST_WEB_FINISHED');
export const enableGuestWebFailed = createAction<EnableGuestWebResultPayload>('ENABLE_GUEST_WEB_FAILED');
